import { useState, useEffect, useContext } from 'react'
import AuthContext from 'contexte/AuthContext'
import { fetchLeverageUserPositions } from 'services/fetchUserById'
import PageLoader from 'components/pageLoader/PageLoader'
import Tableau from 'components/DataComponents/Tableau/Tableau'
import './agbkUserDepositsWithdrawals.css'
import { useTranslation } from 'react-i18next';
import Notification from 'components/notifications/Notification'
import { launchError } from 'components/notifications'
import TickerImage from 'components/DataComponents/TickerImage/TickerImage'
import { fetchAgbkUserDepositsWithdrawals } from 'services/agoServices'
import { formatDate, RELEASE_DATE } from 'utils/date'
import Badge from 'components/Badge/Badge'
import colors from 'assets/colors'





const AgbkUserDepositsWithdrawals = ({ id }) => {

  const { user } = useContext(AuthContext)
  const { t } = useTranslation()

  const [loading, setLoading] = useState(true)
  const [depositsWithdrawals, setDepositsWithdrawals] = useState([])
  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState(10)

  const tableHeaders = ['Type', 'Montant', 'Méthode', 'Date']


  const fetchData = async () => {
    try {
      console.log('fetchdata')
      const data = await fetchAgbkUserDepositsWithdrawals(user, id, page, limit)
      setDepositsWithdrawals(data)
      setLoading(false)
    } catch {
      console.log('error')
    }
  }

  useEffect(() => {
    fetchData()
  }, [page])

  const transformeDataToTbody = (data) => {
    return data.length && data.map((item, index) => {
      if (!item) return { data: [] }


      return {
        data: [
          item.type.toUpperCase(),
          item.amount,
          item.method,
          formatDate({ date: item.updated_at, month: 'long', time: true })
        ]
      }
    })
  }

  return (
    <div>
      {
        !loading ? (
          <div>
            <Notification />
            <Tableau
              tbody={transformeDataToTbody(depositsWithdrawals)}
              thead={tableHeaders}
              limit={limit}
              pagination={true}
              setPage={setPage}
              page={page}
            />
          </div>
        ) : (
          <div className='pageLoaderBox'>
            <PageLoader />
          </div>
        )
      }
    </div>
  )
}

export default AgbkUserDepositsWithdrawals